import { Comment } from "~/common/utils";
import { COMMENT_TITLE } from "~/patients/constants";

export const getScriptCommentMessage = (comments: Comment[]) =>
  comments.find(
    (comment) => comment.title === COMMENT_TITLE.REOPENED_BY_PATIENT,
  )?.text;
